import script from "./SpinnerComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpinnerComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SpinnerComponent.vue?vue&type=style&index=0&id=49c802f0&lang=css"

const __exports__ = script;

export default __exports__